import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white py-20 px-4" data-id="element-71">
      <div className="max-w-3xl mx-auto text-center" data-id="element-72">
        <div className="flex justify-center mb-8" data-id="element-73">
          <div className="bg-[#1f2e10] p-6 rounded-full text-[#c4f000] shadow-xl" data-id="element-74">
            <ShieldCheck size={72} data-id="element-75" />
          </div>
        </div>

        <h2 className="text-3xl md:text-4xl font-extrabold text-[#1f2e10] mb-8 uppercase tracking-wide" data-id="element-76">
          GARANZIA 30 GIORNI
        </h2>

        <p className="text-gray-600 text-xl mb-8 leading-relaxed font-medium" data-id="element-77">
          Prova Merende Felici senza alcun rischio.
        </p>

        <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-78">
          Se non ritieni che il materiale ti aiuti a organizzare meglio
          l'alimentazione della tua famiglia, potrai richiedere il rimborso
          entro 30 giorni.
        </p>

        <div className="inline-block bg-green-50 text-green-800 font-black text-xl px-8 py-4 rounded-full border-2 border-green-200" data-id="element-79">
          Zero rischi.
        </div>
      </div>
    </section>;
}